import React from 'react'
import { pick, flatten, isArray, join, map, compact } from 'lodash'
import CopyButton from "UI/CopyButton";

const ShareableButton = ({ filters, defaultFilters }) => {
  const filtersToUse = pick(filters, compact(map(filters, (value, key) => value != defaultFilters[key] && key)))
  const filtersToUrl = map(filtersToUse, (value, key) => {
    if (isArray(value)) { return map(value, ({ value: arrayValue }) => `filters[${key}][]=${arrayValue}`) }

    return `filters[${key}]=${value}`
  })

  const filtersToCopy = `?${join(flatten(filtersToUrl), '&')}`
  const textToCopy = location.host + location.pathname + filtersToCopy

  return (
    <CopyButton className='btn btn-success align-self-center align-items-center' textToCopy={textToCopy} icon='share-alt'>
      Share
    </CopyButton>
  )
}

export default ShareableButton
